import React from "react";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

/**
 * Renders children only when the user has the required permission (or is Super
 * Admin). Otherwise shows a simple Access Denied panel. This is a UX guard —
 * the backend independently enforces every permission, so a direct API call
 * from a restricted admin still returns 403.
 */
export function RequirePermission({ perm, superOnly = false, children }) {
  const { user, hasPerm } = useAuth();
  const allowed = superOnly ? !!user?.is_super_admin : (!perm || hasPerm(perm));
  if (allowed) return children;
  return (
    <div className="flex flex-1 items-center justify-center p-10" data-testid="access-denied">
      <div className="max-w-sm text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-danger-bg text-danger">
          <ShieldAlert size={26} strokeWidth={1.5} />
        </div>
        <h2 className="font-heading text-lg font-semibold text-text-main">Access Denied</h2>
        <p className="mt-1 text-sm text-text-muted">
          You don't have permission to view this page. Contact your Super Admin if you need access.
        </p>
      </div>
    </div>
  );
}
